import React, {
  useEffect,
  useMemo,
  useState,
} from 'react';

import { useTheme } from '@mui/material/styles';

import TagReminderModal from '../../pages/settings/TaskPage/reminders/components/TagReminder/components/TagReminderModal';
import ReminderContext from './context';
import HorseTaskReminderIndicator from './Indicator';
import useHorseTaskReminders from './useHorseTaskReminders';

export { HorseTaskReminderIndicator };

const HorseTaskReminders = ({
  pairs,
  children,
  open = true,
  disabled = false,
  refreshKey = null,
}) => {
  const theme = useTheme();
  const lookup = useHorseTaskReminders({
    pairs,
    open,
    disabled,
    refreshKey,
  });
  const [preview, setPreview] = useState(null);
  const {
    contextKey,
    reminders,
    loading,
    error,
    reload,
    updateReminder,
    removeReminder,
  } = lookup;
  useEffect(() => setPreview(null), [contextKey]);
  const value = useMemo(() => ({
    reminders,
    loading,
    error,
    reload,
    disabled,
    openReminder: (reminder) => {
      if (!disabled) {
        setPreview({
          contextKey,
          reminder,
        });
      }
    },
  }), [contextKey, reminders, loading, error, reload, disabled]);
  const previewVisible = open && preview?.contextKey === contextKey;
  return (
    <ReminderContext.Provider value={value}>
      {children}
      {previewVisible && (
        <TagReminderModal
          open
          readOnly
          tagReminder={preview.reminder}
          zIndex={theme.zIndex.modal + 1}
          onReminderRefresh={updateReminder}
          onReminderUnavailable={removeReminder}
          onClose={() => setPreview(null)}
        />
      )}
    </ReminderContext.Provider>
  );
};

export default HorseTaskReminders;
